// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-details-panel {
  background-color: rgba( 248, 248, 248 ,  1 );
  background-color: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
}

/*# sourceMappingURL=DetailsPanel.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/DetailsPanel/DetailsPanel.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/DetailsPanel/DetailsPanel.css"],"names":[],"mappings":"AACA;EACI,4CC0FQ;EC1FV,qEAAqE;AACvE;;AAEA,2CAA2C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
